import {
  Box,
  DatePicker,
  Field,
  FilterTableWithQueryParams,
  Grid,
  Select,
  TextField,
} from "components";
import { allOption } from "constants/objects/claim_request_mapping_status";
import { EnumHospitalImportStatus } from "constants/enums/hospital_import_status";
import { compose, withHooks, withTranslation } from "enhancers";
import paths from "routes/paths";
import { createYupDateObject, Yup } from "utils/helper";

interface IHospitalImportListFilterInput {
  name?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
}

export const hospitalImportListFilterInitialValues: IHospitalImportListFilterInput = {
  name: "",
  status: "all",
  startDate: undefined,
  endDate: undefined,
};

const validationSchema = Yup.object().shape({
  startDate: createYupDateObject("startDate", "endDate", "LTE"),
  endDate: createYupDateObject("endDate", "startDate", "GTE"),
});

const HospitalImportFilters = ({ t }: any) => (
  <FilterTableWithQueryParams
    initialValues={hospitalImportListFilterInitialValues}
    path={paths.hospitalImportPath}
    validationSchema={validationSchema}
  >
    <Box display="flex" flexDirection="column">
      <Grid container spacing={6} mt={6}>
        <Grid item xs={3}>
          <Field
            fast
            component={TextField}
            name="name"
            type="text"
            label={t(".name")}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <Field
            fast
            component={Select}
            name="status"
            label={t(".status")}
            options={[
              allOption,
              {
                label: t(".statusOptions.importing"),
                value: EnumHospitalImportStatus.IMPORTING,
              },
              {
                label: t(".statusOptions.processed"),
                value: EnumHospitalImportStatus.PROCESSED,
              },
              {
                label: t(".statusOptions.canceled"),
                value: EnumHospitalImportStatus.CANCELED,
              },
              {
                label: t(".statusOptions.error"),
                value: EnumHospitalImportStatus.ERROR,
              },
            ]}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <Field
            fast
            component={DatePicker}
            name="startDate"
            label={t(".startDate")}
            fullWidth
            clearable
          />
        </Grid>
        <Grid item xs={3}>
          <Field
            fast
            component={DatePicker}
            name="endDate"
            label={t(".endDate")}
            fullWidth
            clearable
          />
        </Grid>
      </Grid>
    </Box>
  </FilterTableWithQueryParams>
);

const enhancer = compose(
  withTranslation({
    prefix: "pages.main.hospitalImport.filters",
  }),
  withHooks((props: any, hooks: any) => {
    const { t } = props;

    return { t };
  })
);

export default enhancer(HospitalImportFilters);
